<template>
  <div class="row">
    <div class="col-md-12">
      <Medicine :group_prescription_medicine="group_prescription_medicine" />
    </div>
    <div class="col-md-12">
      <ErrorsMessages :errors="errors" />
    </div>
    <div class="col-md-12 text-right">
      <v-btn :disabled="loading" @click="separate" class="btn-modern btn-modern-save">
        {{ loading ? "CARREGANDO" : "AVANÇAR" }}
        <i class="fas fa-arrow-right ml-2 text-twenty"></i>
      </v-btn>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../Components/ErrorsMessages";

import api from "../../../../services/api";

import toast from "../../../../lib/ToastNotification";

import Medicine from "../Medicine";

export default {
  name: "NotSeparate",
  components: { Medicine, ErrorsMessages },
  props: {
    group_prescription_medicine: Object,
    medicine_check: Object,
  },
  data() {
    return {
      loading: false,
      errors: [],
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    retrieve() {},
    async separate() {
      try {
        this.loading = true;

        let {
          medicine_check: { id },
        } = this;

        let params = { id };

        const response = await api.post(
          "/rest-home/check/not-separate",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.$emit("success");
          this.$emit("checked");
          this.errors = [];
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
